import templateUrl from "emun.auth/users/user-manager.htm";
import multiviewTemplate from "emun.auth/users/user-manager.multi-view.htm";
import listTemplate from "emun.auth/users/user-manager.list.htm";
import gridTemplate from "emun.auth/users/user-manager.grid.htm";
import headerTemplate from "emun.auth/users/user-manager.header.htm";
import actionsTemplate from "emun.auth/users/user-manager.actions.htm";
import controller from "emun.auth/users/user-manager.controller";

export default {
  bindings: {
    hideLeftNav: "@",
    hideHeader: "@",
    hideEmptyGroupings: "@",
    maxPanelHeight: "@",
    panelMaxHeight: "@",
    hideGroupingCounts: "@",
    panelType: "@",
    actions: "@", //select,detail,applyToProducts,addToDesign
    title: "@",
    disableQueryString: "<?",
    criteria: "<?",
    tagCriteria: "<?",
    queryOptions: "<?",
    navs: "<?",
    filters: "<?",
    onPublish: "&",
    onSaved: "&"
  },
  controller,
  templateUrl($element, $attrs) {
    if ($attrs.templateUrl) return $attrs.templateUrl;
    else if ($attrs.type === "multiview" || $attrs.type === "multi-view")
      return multiviewTemplate;
    else if ($attrs.type === "list") return listTemplate;
    else if ($attrs.type === "grid") return gridTemplate;
    else if ($attrs.type === "header") return headerTemplate;
    else if ($attrs.type === "actions") return actionsTemplate;
    return templateUrl;
  }
};
